import React from 'react'

import styles from './BuyCards.module.css'

const AuthorInfoCard = ({ story }) => {
  return <div className={styles['author-info']}>
    <div className={styles.left}>
      <img src={require(`../../../assets/images/buy_cards/${story.author.imgName}.png`)} className={styles.avator} />
    </div>
    <div className={styles.right}>
      <div className={styles.name}>{story.author.name}</div>
      {story.author.sign && <div className={styles['desc-strong']}>{story.author.sign}</div>}
      {story.author.desc.map((d) => <div className={styles.desc}>{d}</div>)}
    </div>
  </div>
}

export default AuthorInfoCard